import React from "react"
import { Row, Col, Button, Menu, Dropdown, message, Grid } from "antd"
import { FaBars, FaChevronDown, FaSignOutAlt } from "react-icons/fa"
import styled from "styled-components"
import { useMutation } from "react-query"
import * as API from "common/api"
import * as COMMONS from "common/common"
import { useNavigate } from "react-router-dom"

const CustomMenuButton = styled(Button)`
  & {
    border: none;
    box-shadow: none;
  }

  &:hover {
    border: none;
    box-shadow: none;
  }

  &:focus {
    border: none;
    box-shadow: none;
  }

  &:active {
    border: none;
    box-shadow: none;
  }
`

const { useBreakpoint } = Grid

const Topbar = (props) => {
  const { isHamburger, collapseToggle, auth } = props

  const navigate = useNavigate()

  const breakpoint = useBreakpoint()
  const isSmallScreen = !breakpoint.sm

  const logoutMutation = useMutation(API.ADMIN_LOGOUT, {
    onSuccess: (response) => {
      message.success(COMMONS.SUCCESS_LOGOUT_MSG)
      navigate(COMMONS.ADMIN_LOGIN_ROUTE)
    },
    onError: (error) => {
      if (error?.response?.status === COMMONS.RESPONSE_SYSTEM_ERROR) {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      } else {
        message.error(COMMONS.ERROR_SYSTEM_MSG)
      }
    },
  })

  const logoutHandler = () => {
    logoutMutation.mutate()
  }

  const handleMenuClick = (e) => {
    switch (e.key) {
      case "logout":
        logoutHandler()
        break
      default:
        return
    }
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item
        key="logout"
        icon={<FaSignOutAlt className="text-sm text-red-600" />}
      >
        <p className="text-sm">ログアウト</p>
      </Menu.Item>
    </Menu>
  )

  return (
    <>
      {isHamburger ? (
        <Row align="middle" justify="space-between" className="px-5">
          <Col className="text-left cursor-pointer">
            <CustomMenuButton
              type="text"
              icon={<FaBars className="text-2xl text-primary" />}
              onClick={collapseToggle}
            />
          </Col>
          <Row align="middle" justify="end">
            {process.env.REACT_APP_SMAREGI_POS_URL && !isSmallScreen ? (
              <Col className="mr-2">
                <Button
                  icon={
                    <img
                      src="/smaregi.png"
                      alt="スマレジロゴ"
                      className="anticon w-4 h-4"
                    />
                  }
                  type="link"
                  href={process.env.REACT_APP_SMAREGI_POS_URL}
                  target="_blank"
                  className="!border-dashed underline text-smaregi"
                >
                  スマレジ管理
                </Button>
              </Col>
            ) : (
              ""
            )}
            <Col>
              <Dropdown overlay={menu} trigger={["click"]}>
                <Button icon={<FaChevronDown className="anticon" />}>
                  契約ID：
                  {(auth.contractId && auth.contractId.toUpperCase()) || ""}
                </Button>
              </Dropdown>
            </Col>
          </Row>
        </Row>
      ) : (
        <Row justify="end" align="middle" className="px-5">
          {process.env.REACT_APP_SMAREGI_POS_URL && (
            <Col className="mr-2">
              <Button
                icon={
                  <img
                    src="/smaregi.png"
                    alt="スマレジロゴ"
                    className="anticon w-4 h-4"
                  />
                }
                type="link"
                href={process.env.REACT_APP_SMAREGI_POS_URL}
                target="_blank"
                className="!border-dashed !border-smaregi text-smaregi"
              >
                スマレジ管理
              </Button>
            </Col>
          )}
          <Col>
            <Dropdown overlay={menu} trigger={["click"]}>
              <Button icon={<FaChevronDown className="anticon" />}>
                契約ID：
                {(auth.contractId && auth.contractId.toUpperCase()) || ""}
              </Button>
            </Dropdown>
          </Col>
        </Row>
      )}
    </>
  )
}

export default Topbar
